<div class="popupbg" >
    <div class="popupcont">
        <div class="basicrow f-black f-mildt roboto-m">
            Balance Vencido
        </div>
        <div class="basicrow f-black f-reg m-top-i text-justify">
            Para Continuar con su referido debe emtir el pago del balance vencido, Para detalles, verifique los t&eacute;rminos y condiciones de este Programa.
        </div>
        <div class="basicrow m-top-i">
            <div class="logline full"></div>
        </div>
        <div class="basicrow m-top-i">
            <div class="balancesptr-ii text-center refdef">
                <span class="roboto-b">
                    Balance Vencido
                </span><br>
                <span class="f-red f-lsemi roboto-b">
                    {{this.expiredBalance | currency}}{{this.cr}}
                </span>
            </div>
            <div class="basicrow visible-xs">
                <div class="logline full"></div>
            </div>
            <div class="balancesptr-ii ref-nbrd refdef">
                <label class="label-r roboto-b">Monto a Pagar (&#36;)</label>
                <div class="basicrow rel">
                    <input id="balanceCustom" [appOnlyAmount] type="text" [(ngModel)]="this.currentBalance" class="inp-f refdefnt qt" readonly>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-u">
            <div class="logline full"></div>
        </div>
        <div class="basicrow text-center m-top">
            <a (click)="this.payBalance();" class="btns def-i red pull-right vcenter">
                <span class="tabcell">
                    Pagar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
            <a (click)="this.close();" class="btns def-i gray pull-left vcenter">
                <span class="tabcell">
                    Cancelar
                </span>
            </a>
        </div>
    </div>
</div>
